import slugify from 'slugify'

export namespace ExportType {
  export enum Values {
    GLOBAL_STUDENTS= 'GLOBAL_STUDENTS',
    DIAGNOSTIC = 'DIAGNOSTIC',
    MODULE_RESULTS = 'MODULE_RESULTS',
    LOGIN_HISTORY = 'LOGIN_HISTORY'
  }

  export function label(exportType: Values) {
    switch (exportType) {
      case Values.GLOBAL_STUDENTS:
        return 'Données élèves'
      case Values.DIAGNOSTIC:
        return 'Résultat diagnostic'
      case Values.MODULE_RESULTS:
        return 'Résultat modules'
      case Values.LOGIN_HISTORY:
        return 'Connexions & activité'
    }
  }

  /**
   * Slugify the value of an enum
   * @param exportType
   */
  export function slug(exportType: Values) {
    return slugify(exportType, { lower: true }).replaceAll(/_/g, '-')
  }

  export const options = Object.values(Values).map((type) => ({
    value: type,
    label: label(type)
  }))
}
